function isDevOrTest(): boolean {
  return ["development", "test"].includes(process.env.NODE_ENV);
}

export { isDevOrTest };
